import { useEffect, useState } from "react";

export type Theme = "light" | "dark";

const STORAGE_KEY = "altheia-theme";

function read(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

function apply(v: Theme) {
  if (v === "dark") document.documentElement.setAttribute("data-theme", "dark");
  else document.documentElement.removeAttribute("data-theme");
  try {
    localStorage.setItem(STORAGE_KEY, v);
  } catch {
    /* localStorage may be blocked */
  }
}

export function useTheme(): [Theme, (v: Theme) => void, () => void] {
  const [theme, setTheme] = useState<Theme>(read);

  // Sync across tabs / components that share this hook.
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setTheme(read());
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const set = (v: Theme) => {
    setTheme(v);
    apply(v);
  };
  const toggle = () => set(theme === "dark" ? "light" : "dark");
  return [theme, set, toggle];
}
